const categories = {
  21867: {
    carouselCatId: 26416,
    title: "facebody_plp_bath_carousel_title",
    subtitle: "facebody_plp_bath_carousel_subtitle"
  },
  15363: {
    carouselCatId: 16794,
    title: "facebody_plp_eyelashes_carousel_title",
    subtitle: "facebody_plp_eyelashes_carousel_subtitle"
  },
  11412: {
    carouselCatId: 5021,
    title: "facebody_plp_haircare_carousel_title",
    subtitle: "facebody_plp_haircare_carousel_subtitle"
  },
  6461: {
    carouselCatId: 5607,
    title: "facebody_plp_nailpolish_carousel_title",
    subtitle: "facebody_plp_nailpolish_carousel_subtitle"
  },
  5678: {
    carouselCatId: 25399,
    title: "facebody_plp_grooming_carousel_title",
    subtitle: "facebody_plp_grooming_carousel_subtitle"
  }
};

export default categories;
